import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-logout',
  template: `<p>Logging out...</p>`,
})
export class Logout implements OnInit {
  private router = inject(Router);

  ngOnInit(): void {
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate(['/']);
  }
}
